<template>
	<div>

		<h3 style="margin: 0">Manage shipping</h3>
		<p>
			Select where the package should be simulated to be below.
			You can modify the days ago accordingly.
		</p>

		<div
			class="flex shipping-item"
			style="align-items: center"
			v-for="(block, b) in blocks"
			v-if="!block.hide">

			<div
				class="flex clickable shipping-item-title"
				style="align-items: center"
				v-on:click="set(b)"
				v-on:mouseenter="hover = b"
				v-on:mouseleave="hover = null"
				v-bind:class="{
					hovered: hovered[b],
					active: block.value != undefined,
				}">
				<div
					class="shipping-icon">
					<SvgIcon
						:name="block.icon"
						/>
				</div>
				<div>
					<div class="shipping-dot"></div>
				</div>

				<div
					style="width: 300px"
					class="small-margin-left">
					{{ block.title }}
				</div>
			</div>

			<MaterialNumber
				style="width: 100px"
				v-model="block.value"
				label="Days ago"
				v-on:change="valueChanged(b, $event)"
				/>
		</div>

		<button
			class="small small-margin-bottom small-margin-top"
			v-on:click="customerHasKeptBox">Customer kept box</button>

		<div
			style="font-style: italic;">When saving the shipping company will be changed to Test Shipping Company</div>

		<div
			class="margin-top">
			<button
				v-on:click="update"
				:disabled="saving"
				class="">Confirm</button>
		</div>

	</div>
</template>

<script>
import Vue from 'vue'

export default {
  props: {
    id: {
      required: true
    },
    data: {
      required: true
    }
  },
  computed: {
    hovered () {
      var list = {}

      if (this.hover == null) {
        return list
      }

      for (var j = this.hover; j >= 0; j--) {
        if (this.blocks[j].terminus && this.hover != j) {
          continue
        }

        list[j] = true
      }

      return list
    }
  },
  data: () => ({
    hover: null,
    saving: false,
    trackings: [],
    company: null,
    blocks: [
      {
        column: 'parcel_center_at',
        type: 'shipment',
        daysAgo: 1,
        tracking_number: 'parcel_center',
        title: 'Arrived at parcel center',
        icon: 'parcelcenter'
      },
      {
        column: 'parcelshop_at',
        type: 'shipment',
        daysAgo: 2,
        tracking_number: 'parcelshop',
        title: 'Waiting in parcelshop',
        icon: 'parcelshop'
      },
      {
        column: 'shipment_delivered_at',
        type: 'shipment',
        // also: [['picked_up_at', 'picked_up']],
        daysAgo: 4,
        tracking_number: 'delivered',
        title: 'Delivered to customer',
        icon: 'customer'
      },
      {
        column: 'shipment_delivered_at',
        type: 'shipment',
        hide: true,
        terminus: true,
        daysAgo: 16,
        tracking_number: 'delivered',
        icon: 'customer'
      },
      {
        column: 'returned_to_sender_at',
        type: 'shipment',
        terminus: true,
        daysAgo: 3,
        tracking_number: 'returned_to_sender',
        title: 'Returned to sender',
        icon: 'returned-to-sender'
      },
      {
        column: 'parcelshop_at',
        type: 'return',
        daysAgo: 2,
        tracking_number: 'handed_in',
        title: 'Return delivered to parcelshop',
        icon: 'return-order'
      },
      {
        column: 'parcel_center_at',
        type: 'return',
        daysAgo: 2,
        tracking_number: 'parcel_center',
        title: 'Return arrived at parcel center',
        icon: 'parcelcenter'
      },
      {
        column: 'shipment_delivered_at',
        type: 'return',
        daysAgo: 3,
        tracking_number: 'delivered',
        title: 'Return arrived at warehouse',
        icon: 'warehouse'
      }
    ]
  }),
  methods: {
    customerHasKeptBox () {
      this.set(3)
    },
    valueChanged (b, data) {
      const change = Number(data.new) - Number(data.old)

      for (var i = b; i >= 0; i--) {
        if (this.blocks[i].value != undefined) {
          Vue.set(this.blocks[i], 'value', Number(this.blocks[i].value) + change)
        }
      }
    },
    set (i) {
      var days = 0

      for (var j = 0; j <= this.blocks.length - 1; j++) {
        Vue.set(this.blocks[j], 'value', null)
      }

      for (var k = i; k >= 0; k--) {
        const block = this.blocks[k]

        if (block.terminus && i != k) {
          continue
        }

        days += block.daysAgo

        Vue.set(this.blocks[k], 'value', days)
      }
    },
    toggle (row) {
      Vue.set(row, '_expand', !row._expand)
    },
    update () {
      Vue.$api.put('/testing/order/' + this.id + '/shipment', {
        trackings: this.blocks
      }, {
        before: () => this.saving = true,
        always: () => this.saving = false,
        callback: () => this.$emit('updated')
      })
    }
  },
  created () {
    this.trackings = this.data.shipment.trackings
    this.company = this.data.shipment.company

    if (this.trackings.length == 2) {
      for (var block of this.blocks) {
        const trackingNo = this.trackings[block.type == 'shipment' ? 0 : 1].tracking_number
        for (var part of trackingNo.split('|')) {
          const event = part.split('#')[0]
          const days = part.split('#')[1]

          if (event == block.tracking_number) {
            Vue.set(block, 'value', days)
          }
        }

        // console.log(block.type, trackingNo)
      }
    }
  }
}
</script>

<style lang="less">
	.shipping-item {
		border-bottom: 1px solid #ccc;
		.shipping-item-title {
			height: 46px;
		padding-bottom: 10px;
		padding-top: 10px;
			.shipping-dot {
				position: relative;
				width: 20px;
				height: 20px;
				border-radius: 50%;
				background: #fff;
				cursor: pointer;
				border: 1px solid #888;
				&::after {
					position: absolute;
					content: "";
					top: 3px;
					bottom: 3px;
					left: 3px;
					right: 3px;
					background: #fff;
					border-radius: 50%;
				}
			}
			.shipping-icon {
				margin-right: 15px;
				.svg-icon, svg {
					width: 24px !important;
					height: 24px !important;
				}
				svg {
					fill: #aaa;
				}
			}
			&.active {
				.shipping-dot::after {
					background: #032A8A;
				}
				.shipping-icon svg {
					fill: #032A8A;
				}
			}
			&.hovered {
				.shipping-dot::after {
					background: #9237FF;
				}
				.shipping-icon svg {
					fill: #9237FF;
				}
			}
		}
	}
</style>
